import { render, staticRenderFns } from "./register.vue?vue&type=template&id=0d589b9c&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&lang=css&"
import style1 from "./register.vue?vue&type=style&index=1&id=0d589b9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d589b9c",
  null
  
)

export default component.exports